import { CircleAlert } from "lucide-react";

const Fail = ({ closeDocumentFail }) => {
  return (
    <div
      onClick={(e) => {
        closeDocumentFail();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[500px] h-[250px] flex flex-col justify-center items-center gap-[10px] rounded-[20px] p-[20px] relative bg-white"
      >
        <CircleAlert color="#F4A261" />
        <p className="text-[#5C5C5C] text-[16px] font-semibold">
          Sorry the documents could not be sent..
        </p>
        <p className="text-[#5C5C5C] text-[16px] text-center font-semibold">
          Make sure the Loan application complete; all sections of the loan
          application should be complete
        </p>
        <button
          onClick={closeDocumentFail}
          className="h-[35px] rounded-[30px] bg-[#F3F3F3] px-[20px] text-[#5C5C5C] font-medium text-[15px]"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default Fail;
